module.exports = __webpack_public_path__ + "img/Music-icon.c40d5f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Music-icon.png
// module id = 160
// module chunks = 2